import React, { Component } from "react";
import { Layout } from "antd";
import { connect } from "react-redux";
import {
  setActiveLanguage,
  getActiveLanguage,
  getTranslate
} from "react-localize-redux";
import { logoutAction } from "../login/loginActions";
import TopNav from "./TopNav";

const { Header } = Layout;

class AppHeader extends Component {
  render() {
    return (
      <Header>
        <TopNav
          changeLanguage={this.props.changeLanguage}
          logout={this.props.logoutAction}
          currentLanguage={this.props.currentLanguage}
          translate={this.props.translate}
        />
      </Header>
    );
  }
}

const mapStateToProps = state => {
  return {
    isProcessing: state.login.isProcessing,
    currentLanguage: getActiveLanguage(state.locale)
      ? getActiveLanguage(state.locale).code
      : "en",
    translate: getTranslate(state.locale)
  };
};

const mapDispatchToProps = dispatch => {
  return {
    logoutAction: () => dispatch(logoutAction),
    changeLanguage: lang => dispatch(setActiveLanguage(lang))
  };
};

const connectedPage = connect(
  mapStateToProps,
  mapDispatchToProps
)(AppHeader);
export { connectedPage as AppHeader };
